import axios from 'axios'

export default {
  /**
   * Gets and sets all fleets
   */
  getFleets({ commit, dispatch, rootState }) {
    commit('setFleetsLoaded', false)
    commit('app/setLoading', { type: 'getFleets', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      let url = `${process.env.VUE_APP_URL}/adminapi/fleets`
      if (
        rootState.app.vehicleNumberSearchString &&
        rootState.app.vehicleNumberSearchString !== ''
      ) {
        url = `${process.env.VUE_APP_URL}/adminapi/fleets?vehicleNumber=${rootState.app.vehicleNumberSearchString}`
      }
      axios.get(url, config).then(response => {
        commit('setFleets', response.data)
        commit('setFleetsLoaded', true)
        commit('app/setLoading', { type: '', state: false }, { root: true })
        commit('app/setError', null, { root: true })
      })
    } catch (error) {
      if (error.response.status === 401) {
        dispatch('authentication/logout', null, { root: true })
      }
      commit(
        'app/setLoading',
        { type: 'getFleets', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
      commit('setFleetsLoaded', true)
    }
  },
  /**
   * Gets and sets fleet by fleet id
   * @param {Number} id
   */
  getFleet: async ({ commit, rootState, dispatch }, id) => {
    commit('app/setLoading', { type: 'getFleet', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/fleets/${id}`, config)
        .then(response => {
          commit('setFleet', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getFleet', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Post fleet
   * @param {Object} - fleet object
   */
  postFleet: async ({ commit, rootState }, payload) => {
    commit('app/setLoading', { type: 'postFleet', state: true }, { root: true })
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      if (Array.isArray(payload.Zones)) {
        commit('setFleetValue', {
          key: 'Zones',
          value: `|${payload.Zones.join('|')}|`
        })
      }
      if (payload.ID) {
        await axios
          .put(`${process.env.VUE_APP_URL}/adminapi/fleets`, payload, config)
          .then(response => {
            commit('setFleetInFleetsArray', response.data)
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'success',
                message: 'Fleet updated successfully!'
              },
              { root: true }
            )
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
      } else {
        await axios
          .post(`${process.env.VUE_APP_URL}/adminapi/fleets`, payload, config)
          .then(response => {
            commit('addFleet', response.data)
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'success',
                message: 'New fleet added successfully!'
              },
              { root: true }
            )
            commit(
              'app/setLoading',
              { type: 'postFleet', state: false },
              { root: true }
            )
            commit('app/setError', null, { root: true })
          })
      }
    } catch (error) {
      if (payload.Zones && payload.Zones.length) {
        commit('setFleetValue', {
          key: 'Zones',
          value: payload.Zones.slice(1, -1).split('|')
        })
      }
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message:
            error.response && error.response.data
              ? error.response.data.Error
              : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'postFleet', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Gets and sets fleet users by fleet id
   * @param {Number} id - fleet id
   */
  getFleetUsers: async ({ commit, rootState }, id) => {
    commit(
      'app/setLoading',
      { type: 'getFleetUsers', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .get(`${process.env.VUE_APP_URL}/adminapi/fleets/${id}/users`, config)
        .then(response => {
          commit('setFleetValue', {
            key: 'Users',
            value: response.data
          })
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setLoading',
        { type: 'getFleetUsers', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Post fleet user
   * @param {WhitelistUser} - fleet user object
   */
  postFleetUser: async ({ commit, state, rootState }, payload) => {
    commit(
      'app/setLoading',
      { type: 'postFleetUser', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      // if (payload.ClientId.length) {
      //   payload.ClientId = Number(payload.ClientId)
      // }
      let params = ''
      if (payload.RegistrationType === 'MANUALLY_INVITED') {
        params = '?invite=true'
      }
      if (payload.ID) {
        await axios
          .put(
            `${process.env.VUE_APP_URL}/adminapi/fleets/${payload.FleetId}/users${params}`,
            payload,
            config
          )
          .then(response => {
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'success',
                message: 'User updated successfully!'
              },
              { root: true }
            )
            commit('updateFleetUser', response.data)
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
      } else {
        await axios
          .post(
            `${process.env.VUE_APP_URL}/adminapi/fleets/${state.currentFleetId}/users`,
            payload,
            config
          )
          .then(response => {
            commit('addUserToFleet', response.data)
            commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'success',
                message: 'User added successfully!'
              },
              { root: true }
            )
            commit(
              'app/setLoading',
              { type: 'postFleetUser', state: false },
              { root: true }
            )
            commit('app/setError', null, { root: true })
          })
      }
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message:
            error.response && error.response.data
              ? error.response.data.Error
              : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'postFleetUser', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Post fleet user
   * @param {FleetUser} - fleet user object
   */
  postFleetUsers: async ({ commit, state, rootState }, payload) => {
    commit(
      'app/setLoading',
      { type: 'postFleetUsers', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/fleets/${state.currentFleetId}/users?many=true`,
          payload,
          config
        )
        .then(response => {
          response.data.forEach(user => {
            commit('addUserToFleet', user)
          })
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: 'Users added successfully!'
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'postFleetUsers', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message:
            error.response && error.response.data
              ? error.response.data.Error
              : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'postFleetUsers', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Delete fleet user
   * @param {FleetUser} - fleet user object
   */
  deleteFleetUser: async ({ commit, rootState }, payload) => {
    commit(
      'app/setLoading',
      { type: 'deleteFleetUser', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .delete(
          `${process.env.VUE_APP_URL}/adminapi/fleets/${payload.FleetId}/users`,
          { headers: config.headers, data: payload }
        )
        .then(() => {
          commit('removeFleetUser', payload)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: 'User removed successfully'
            },
            { root: true }
          )
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message: error.response.data
            ? error.response.data.Error
            : 'Something went wrong! Please try again later.'
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'deleteFleetUser', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Gets and sets fleet availability info by fleet id
   * @param {Number} payload - { fleetId: xxxx, <year: xxxx, month: x> }
   */
  getAvailabilityInfo: async ({ commit, dispatch, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'fleets.getAvailabilityInfo', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      const now = new Date()
      const currentYear = now.getFullYear()
      const currentMonth = now.getMonth() + 1
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/fleets/${
            payload.fleetId
          }/report?year=${payload.year ? payload.year : currentYear}&month=${
            payload.month ? payload.month : currentMonth
          }`,
          config
        )
        .then(response => {
          resolve(response)
          commit('setAvailabilityInfo', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          reject(error)
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'fleets.getAvailabilityInfo', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
        })
    })
  },
  getFleetActiveSessions: async ({ commit, dispatch, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getFleetActiveSessions', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })

      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/fleets/${payload.fleetId}/active-sessions`,
          config
        )
        .then(response => {
          resolve(response)
          commit('setAvailabilityInfo', response.data)
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
        .catch(error => {
          reject(error)
          if (error.response.status === 401) {
            dispatch('authentication/logout', null, { root: true })
          }
          commit(
            'app/setLoading',
            { type: 'getFleetActiveSessions', state: false },
            { root: true }
          )
          commit('app/setError', error, { root: true })
        })
    })
  },
  /**
   * Get info for session start dialog by fleetId and fleetUserId
   * @param {Number} payload - { fleetId: xxxx, fleetUserId: xxxx }
   */
  getInfoForSessionStart: ({ commit, dispatch, rootState }, payload) => {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getInfoForSessionStart', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
        }
        axios
          .get(
            `${process.env.VUE_APP_URL}/adminapi/fleets/${payload.fleetId}/users/${payload.fleetUserId}/visitor-session`,
            config
          )
          .then(response => {
            // commit('setAvailabilityInfo', response.data)
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
            resolve(response)
          })
          .catch(error => {
            if (error.response.status === 401) {
              dispatch('authentication/logout', null, { root: true })
            } else {
              commit(
                'app/setLoading',
                { type: 'getInfoForSessionStart', state: false },
                { root: true }
              )
              commit('app/setError', error, { root: true })
            }
          })
      } catch (error) {
        commit(
          'app/setLoading',
          { type: 'getInfoForSessionStart', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
        reject(error)
      }
    })
  },
  /**
   * Starts new session under fleet by fleetId and fleetUserId
   * @param {Number} payload - { fleetId: xxxx, fleetUserId: xxxx }
   */
  startNewSession: async ({ commit, dispatch, rootState }, payload) => {
    if (!payload.hours) {
      payload.hours = 0
    }
    if (!payload.minutes) {
      payload.minutes = 0
    }
    if (!payload.days) {
      payload.days = 0
    }
    const daysToHours = payload.days * 24
    const hours = daysToHours + payload.hours

    commit(
      'app/setLoading',
      { type: 'startNewSession', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .post(
          `${process.env.VUE_APP_URL}/adminapi/fleets/${payload.fleetId}/users/${payload.fleetUserId}/visitor-session`,
          {
            PlaceId: payload.placeId,
            CarNumber: payload.carNumber,
            Hours: hours,
            Minutes: payload.minutes
          },
          config
        )
        .then(() => {
          dispatch('getAvailabilityInfo', { fleetId: payload.fleetId })
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: `New session added successfully`
            },
            { root: true }
          )
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      if (error.response.status === 401) {
        dispatch('authentication/logout', null, { root: true })
      }
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message: error.response.data
            ? error.response.data.Error
            : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'startNewSession', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   *
   * @param {Object} payload - { fleetId: xxxx, fleetUserId: xxxx }
   */
  putSession: async ({ commit, dispatch, rootState }, payload) => {
    commit(
      'app/setLoading',
      { type: 'startNewSession', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/fleets/${payload.fleetId}/users/${payload.fleetUserId}/visitor-session/${payload.sessionId}/extend-time`,
          {
            PlaceId: payload.placeId,
            CarNumber: payload.carNumber,
            Hours: payload.hours
          },
          config
        )
        .then(() => {
          dispatch('getAvailabilityInfo', { fleetId: payload.fleetId })
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: payload.this.$vuetify.lang.t('$vuetify.TIME_EXTENDED')
            },
            { root: true }
          )
          commit('app/setLoading', { type: '', state: false }, { root: true })
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message: error.response.data
            ? error.response.data.Error
            : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'startNewSession', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  },
  /**
   * Generates Excel reports file for fleet
   */
  getFleetXLSX({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit(
        'app/setLoading',
        { type: 'getFleetXLSX', state: true },
        { root: true }
      )
      commit('app/setError', null, { root: true })
      try {
        const config = {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${rootState.authentication.jwt}`,
            Accept:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
        }
        axios
          .get(
            `${process.env.VUE_APP_URL}/adminapi/fleets/${payload.id}/report?year=${payload.year}&month=${payload.month}`,
            config
          )
          .then(response => {
            resolve(response)
            commit('app/setLoading', { type: '', state: false }, { root: true })
            commit('app/setError', null, { root: true })
          })
      } catch (error) {
        reject(error)
        commit(
          'app/setLoading',
          { type: 'getFleetXLSX', state: false },
          { root: true }
        )
        commit('app/setError', error, { root: true })
      }
    })
  },
  /**
   * Accept or Decline PENDING status fleet user
   * @param {Params} - {fleetUserId, status}
   */
  updateAndSaveFleetUserStatus: async (
    { commit, state, rootState },
    { fleetUserId, status }
  ) => {
    commit(
      'app/setLoading',
      { type: 'updateAndSaveFleetUserStatus', state: true },
      { root: true }
    )
    commit('app/setError', null, { root: true })
    try {
      const config = {
        headers: { Authorization: `Bearer ${rootState.authentication.jwt}` }
      }
      await axios
        .put(
          `${process.env.VUE_APP_URL}/adminapi/fleets/${state.currentFleetId}/users/${fleetUserId}/status/${status}`,
          null,
          config
        )
        .then(response => {
          commit('removeFleetUser', response.data)
          commit('addUserToFleet', response.data)
          commit(
            'app/setSnackbar',
            {
              show: true,
              type: 'success',
              message: 'Status updated successfully'
            },
            { root: true }
          )
          commit(
            'app/setLoading',
            { type: 'updateAndSaveFleetUserStatus', state: false },
            { root: true }
          )
          commit('app/setError', null, { root: true })
        })
    } catch (error) {
      commit(
        'app/setSnackbar',
        {
          show: true,
          type: 'error',
          message:
            error.response && error.response.data
              ? error.response.data.Error
              : `Something went wrong! Please try again later.`
        },
        { root: true }
      )
      commit(
        'app/setLoading',
        { type: 'updateAndSaveWhitelistUserStatus', state: false },
        { root: true }
      )
      commit('app/setError', error, { root: true })
    }
  }
}
